import React from 'react';
import styles from './AboutDarts.module.scss';
import AboutDartsPages from "./Pages/AboutDartsPages";
import AboutDartsWidgets from "./Pages/AboutDartsWidgets";



const AboutDarts: React.FC = () => {
    return (
        <div className={styles.about}>
            <header id="introduction" className={styles.header}>
                <h1>Welcome to the Darts Data Collection web application!</h1>
                <p>This platform is designed to <b>enhance your darts experience</b> by providing <b>real-time data collection</b>, analytics, and insights for players and teams.</p>
                <p>Whether you're a <b>casual player</b> or a <b>professional</b>, SDC Group offers tools to track your performance, analyze your games, and improve your skills.</p>
            </header>
            <section className={styles.section}>
                <h2>Key Features</h2>
                <ul>
                    <li><b>Full cycle</b> for processing games</li>
                    <li>Suitable <b>both</b> for large <b>competitions</b> and for <b>home</b> use</li>
                    <li>Real-time dart match tracking and data broadcasting</li>
                    <li>Can be used on boards, in video streaming or like frame in your website</li>
                    <li>Interactive match analytics and statistics</li>
                    <li>AI-powered player performance insights</li>
                    <li>Low price</li>
                </ul>
            </section>
           <section id="pages" className={styles.section}>
                <h2>Pages</h2>
                <AboutDartsPages/>
            </section>

            <section id="widgets" className={styles.section}>
                <h2>Widgets</h2>
                <AboutDartsWidgets/>
            </section>

            <section className={styles.section}>
                <h2>Start Improving Your Game Today!</h2>
                <h4>Join us and take your darts to the next level with smart data.</h4>
            </section>

            <footer className="footer">
                <p>© 2025 { } – All rights reserved.</p>
            </footer>
        </div>
    );
}

export default AboutDarts;